var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import Button from "../../components/connect-ui/Button";
import Image from "../../components/Image";
import { PHASE } from "../../routeConfig";
import { completedPage } from "../../lib/Avo";
import useAppSelector from "../../hooks/useAppSelector";
import { useHistory } from "react-router-dom";
import useSelectedIssuerNextRoute from "../../features/applicant/useSelectedIssuerNextRoute";
function ListItem(props) {
    return React.createElement("li", __assign({ className: "flex items-center" }, props));
}
function ListItemNumber(props) {
    return (React.createElement("span", __assign({ className: "mr-[10px] inline-flex h-7 w-7 flex-none items-center justify-center rounded-full border border-[#2d3180] text-[15px] font-bold" }, props)));
}
export default function IntroRoute() {
    var push = useHistory().push;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var getSelectedIssuerNextRoute = useSelectedIssuerNextRoute();
    function handleClick() {
        var nextRoute = getSelectedIssuerNextRoute();
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: undefined, optionSelected: undefined }));
        push(nextRoute || PHASE.SELECT_AUTO_ISSUER);
    }
    return (React.createElement("div", { className: "relative -mt-14 flex h-full grow flex-col overflow-hidden pt-14" },
        React.createElement("div", { className: "absolute inset-0 z-[1] w-full bg-[#7FC0E4]" },
            React.createElement(Image, { src: "/assets/images/intro-background-img.svg", alt: "", className: "w-full" })),
        React.createElement("header", { className: "relative z-10 flex h-[40%]", style: { flex: "0 0 40%" } },
            React.createElement("div", { className: "relative z-[1] m-auto flex flex-col items-center justify-center pb-4" },
                React.createElement("h2", { className: "m-0 mb-[6px] text-center text-[26px] font-bold leading-none text-white sm:text-[30px] sm-md:mb-6" },
                    "Save money on",
                    React.createElement("br", null),
                    "Car Insurance"),
                React.createElement(Image, { src: "/assets/images/intro-money-img.svg", width: "135", height: "123", alt: "" }))),
        React.createElement("div", { className: "relative z-10 flex h-[60%] grow flex-col justify-between self-end bg-white px-5 pb-5 pt-4 shadow-[0_-5px_14px_rgba(0,0,0,0.15)] sm-md:p-6", style: { flex: "0 0 60%" } },
            React.createElement("h3", { className: "mb-3 mt-0 text-center text-2xl font-bold leading-none text-[#14141c] sm-md:text-[32px]" }, "How to get started"),
            React.createElement("ol", { className: "m-0 mb-4 list-none space-y-3 p-0 text-lg leading-none sm-md:space-y-6 sm-md:text-xl sm-md:leading-none" },
                React.createElement(ListItem, null,
                    React.createElement(ListItemNumber, null, "1"),
                    React.createElement("span", null, "Log in with your current insurance")),
                React.createElement(ListItem, null,
                    React.createElement(ListItemNumber, null, "2"),
                    React.createElement("span", null, "We'll search for better deals that match your coverage")),
                React.createElement(ListItem, null,
                    React.createElement(ListItemNumber, null, "3"),
                    React.createElement("span", null, "Switch to a better deal for FREE."))),
            React.createElement("div", { className: "w-full px-5 pb-5" },
                React.createElement(Button, { onClick: handleClick }, "Check my policy")))));
}
